/* eslint-disable import/no-anonymous-default-export */
export default {
  head: "Select company",
  selectAll: "Select all companies",
  done: "Done",
};
